import angular from 'angular';

/**
 * Create the kform-builder-component directive.
 * Extend the kform-component directive and change the template.
 *
 * @param {any} kformElementDirective KformComponent directive
 * @returns {any} Directive
 */
const kformBuilderElementDirective = /* @ngInject */ kformElementDirective => angular.extend(
	{},
	kformElementDirective[0],
	{
		scope: false,
		controller: /* @ngInject */ (/** @type {any} */ $scope, /** @type {any} */ KformComponents) => {
			const component = $scope.parent?.component || $scope.component;
			$scope.builder = true;
			$scope.formComponent = KformComponents.components[component.type] || KformComponents.components.custom;
			if ($scope.formComponent.fbtemplate) {
				$scope.template = $scope.formComponent.fbtemplate;
			}
		},
	},
);

export default kformBuilderElementDirective;
